import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { RichTextEditorPlugin } from '@syncfusion/ej2-vue-richtexteditor';

Vue.use(RichTextEditorPlugin);
Vue.use(Vuetify);

export default new Vuetify({
});
